import {
  Box, Button, HStack, Popover, PopoverBody, PopoverContent, PopoverTrigger, Portal,
} from "@chakra-ui/react";
import { ko } from "date-fns/locale";
import { DayPicker } from "react-day-picker";
import { FiCalendar } from "react-icons/fi";
import "react-day-picker/dist/style.css";

import { toLocalDateValue } from "./utils/dateValue";
import TodayButton from "./TodayButton";

export default function DatePicker({
  value,
  onChange,
  width = "100%",
  size = "md",
  isClearable = false,
}) {
  const selected = value ? new Date(`${value}T00:00:00`) : undefined;

  return (
    <Popover placement="bottom-start" gutter={6}>
      {({ onClose }) => (
        <>
          <PopoverTrigger>
            <Button
              size={size}
              variant="outline"
              leftIcon={<FiCalendar />}
              w={width}
              justifyContent="space-between"
              fontWeight="500"
            >
              {value || "날짜 선택"}
            </Button>
          </PopoverTrigger>
          <Portal>
            <PopoverContent w="292px" p={1} zIndex={2000}>
              <PopoverBody px={2} py={2}>
              <Box
                sx={{
                  ".rdp-selected .rdp-day_button": {
                    bg: "#3182CE",
                    color: "white",
                    borderColor: "#3182CE",
                    fontWeight: "700",
                  },
                  ".rdp-today:not(.rdp-selected) .rdp-day_button": {
                    border: "1px solid #3182CE",
                    color: "#2B6CB0",
                    fontWeight: "700",
                  },
                  ".rdp-day_button:hover": { bg: "#EBF8FF" },
                  ".rdp-selected .rdp-day_button:hover": { bg: "#2B6CB0" },
                }}
              >
                <DayPicker
                  mode="single"
                  locale={ko}
                  labels={{
                    labelPrevious: () => "이전 달",
                    labelNext: () => "다음 달",
                    labelMonthDropdown: () => "월 선택",
                    labelYearDropdown: () => "연도 선택",
                    labelDayButton: (date, modifiers) => `${date.toLocaleDateString("ko-KR", { year: "numeric", month: "long", day: "numeric", weekday: "long" })}${modifiers.today ? ", 오늘" : ""}${modifiers.selected ? ", 선택됨" : ""}`,
                  }}
                  weekStartsOn={1}
                  selected={selected}
                  defaultMonth={selected || new Date()}
                  formatters={{
                    formatCaption: (month) => `${month.getFullYear()}년 ${month.getMonth() + 1}월`,
                  }}
                  style={{
                    "--rdp-day-width": "34px",
                    "--rdp-day-height": "34px",
                    "--rdp-day_button-width": "32px",
                    "--rdp-day_button-height": "32px",
                    "--rdp-nav_button-width": "30px",
                    "--rdp-nav_button-height": "30px",
                  }}
                  onSelect={(date) => {
                    if (!date) return;
                    onChange(toLocalDateValue(date));
                    onClose();
                  }}
                />
              </Box>
              <HStack justify="flex-end" mt={2}>
                {isClearable && value && (
                  <Button
                    size="xs"
                    variant="ghost"
                    onClick={() => {
                      onChange("");
                      onClose();
                    }}
                  >
                    날짜 지우기
                  </Button>
                )}
                <TodayButton
                  size="xs"
                  colorScheme="blue"
                  onClick={() => {
                    onChange(toLocalDateValue(new Date()));
                    onClose();
                  }}
                />
              </HStack>
              </PopoverBody>
            </PopoverContent>
          </Portal>
        </>
      )}
    </Popover>
  );
}
